module.exports = __webpack_public_path__ + "static/img/2.0e2e30b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/2.png
// module id = DYrU
// module chunks = 0